export default function CustomList(props) {
	const { title, items, checked, onToggle, onToggleAll, numberOfChecked } =
		props;

	return (
		<div className="p-[8px] m-[8px] bg-white shadow-md rounded-md">
			<div
				className="card-header"
				style={{ display: "flex", alignItems: "center" }}
			>
				<input
					type="checkbox"
					// ref={headerCheckboxRef}
					onChange={onToggleAll(items)}
					checked={
						numberOfChecked(items) === items.length && items.length !== 0
					}
					disabled={items.length === 0}
				/>
				<div style={{ marginLeft: "8px" }}>
					<strong>{title}</strong>
					<div>{`${numberOfChecked(items)}/${
						items.length
					} Items selected`}</div>
				</div>
			</div>
			<hr />
			<ul
				style={{ overflowAnchor: "none" }}
				className="w-[400px] h-[430px] overflow-auto list-none p-0 m-0 space-y-1"
				// ref={listRef}
			>
				{items.map((value) => (
					<li
						key={value.itemno}
						onClick={onToggle(value)}
						style={{
							display: "flex",
							alignItems: "center",
							padding: "4px",
							borderBottom: "1px solid #ddd",
							cursor: "pointer",
						}}
						className={`${
							checked.indexOf(value) !== -1 && "bg-primary text-white"
						} hover:bg-primary hover:text-white rounded-md `}
					>
						<input
							type="checkbox"
							checked={checked.indexOf(value) !== -1}
							readOnly
							style={{ marginRight: "8px" }}
						/>
						<span>{`Item ${value.itemno}: ${value.text}`}</span>
					</li>
				))}
			</ul>
		</div>
	);
}
